import { useState } from "react";
import { HelpCircle, Plus, Minus } from "lucide-react";
import { FAQ_ITEMS } from "@/lib/site-data";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="page-faq" className="bg-[#F7F5F0]">
      <section className="relative py-24 md:py-32 bg-gradient-to-b from-[#4A6D82] to-[#7B98A8] text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <span className="text-xs uppercase tracking-[0.3em] text-[#F4E4C1] flex items-center justify-center gap-2">
            <HelpCircle className="w-3.5 h-3.5" /> Questions de foi
          </span>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.05] mt-4 mb-5">
            Les réponses <em className="not-italic text-[#F4E4C1]">simples</em>.
          </h1>
          <p className="text-lg text-white/85 max-w-2xl mx-auto">
            Réponses simples, directes et bibliques aux questions que se posent la plupart des chrétiens au quotidien.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-6" data-testid="faq-list">
          <div className="space-y-3">
            {FAQ_ITEMS.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`rounded-2xl border transition-all ${isOpen ? "bg-white border-[#4A6D82] jt-soft-shadow" : "bg-white border-[#DDE3E8] hover:border-[#7B98A8]"}`}
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <h3 className="font-serif text-lg md:text-xl text-[#1E2933] leading-tight pr-2">{item.q}</h3>
                    <span className={`h-8 w-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? "bg-[#4A6D82] text-white" : "bg-[#E4EBEF] text-[#4A6D82]"}`}>
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6 jt-fadeUp">
                      <p className="text-[#1E2933]/80 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-14 text-center rounded-2xl bg-white border border-[#DDE3E8] p-8">
            <p className="text-sm text-[#6B7A85] mb-3 uppercase tracking-widest">Une autre question ?</p>
            <p className="font-serif text-2xl text-[#1E2933] mb-4">Écris-nous, nous prendrons le temps de répondre.</p>
            <a href="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#4A6D82] text-white hover:bg-[#2E4959] transition">
              Nous contacter
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
